module.exports = __webpack_public_path__ + "media/images/commercial_offers/turbotrucks-logo-b384ce6592ee97ce6008696677d13382.png";